//#region src/clients/dashboard/v20240509/endpoints/creditNotes/creditNotes.cacheKeys.ts
var e = "creditNotes";
//#endregion
export { e as t };

//# sourceMappingURL=creditNotes.cacheKeys-CnS0uUPf.js.map